// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"d66c58bf","121":"b8808b39","374":"c48adffb","453":"a50e41de","613":"047a44b6","638":"8d91672f"}[chunkId] + ".chunk.js";
};